import React from "react";

export const CellYTd: React.FC<{ value?: string | number | null }> = ({ value }) => {
  return <td className="cell-y">{value ?? ""}</td>;
};
